<template>
  <div>
    <vs-divider />
    <h5 class="mt-4 mb-2">Questions</h5>
    <MeetingStepQuestions :questions="step.questions" />
  </div>
</template>

<script>
import MeetingStepQuestions from "../MeetingStepQuestions.vue";
export default {
  components: {
    MeetingStepQuestions
  },
  props: {
    step: {
      type: Object,
      required: true
    }
  },
  created() {
    this.step.questions = this.step.questions || [];
  }
};
</script>